var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/loadmodules',["require", "exports", "common/parts", "services/httpclient", "areas/navigationmanager/models/dto"], function (require, exports, Parts, Http, Dto) {
    "use strict";
    var LoadModules = (function (_super) {
        __extends(LoadModules, _super);
        function LoadModules() {
            _super.call(this);
        }
        LoadModules.prototype.process = function (symbol) {
            var _this = this;
            var service = new Http.Channel();
            try {
                //service.getData("/api/modules", Http.ServiceTarget.portalApi)
                //	.then(data => {
                //		var result = Enumerable.From(data)
                //			.Select(itm => Dto.ModuleInfo.from(itm))
                //			.ToArray();
                //		this.output.call(result);
                //             });
                service.getData("/activation/api/shop-item/all?$orderby=Name", Http.ServiceTarget.oneClickServiceApi)
                    .then(function (data) {
                    var result = Enumerable.From(data)
                        .Select(function (itm) { return Dto.ModuleInfo.from(itm); })
                        .ToArray();
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return LoadModules;
    }(Parts.Part));
    return LoadModules;
});

